import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Wallet, WalletIban } from 'src/app/models/wallet';
import { IBAN_STATUS, PROFILE_TYPE, DOCUMENT_TYPE } from 'src/app/constants';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { setFormTouched } from 'src/app/utils/form';
import { Subscription } from 'rxjs';
import { Platform, ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {
  PictureSourceType,
  DestinationType,
  EncodingType,
  Camera,
  CameraOptions,
} from '@ionic-native/camera/ngx';
import { UploadDocument } from 'src/app/models/uploadDocument';
import * as moment from 'moment';

// tslint:disable-next-line:max-line-length
const REGEX =
  /^(?=[0-9A-Z]{28}$)AL\d{10}[0-9A-Z]{16}$|^(?=[0-9A-Z]{24}$)AD\d{10}[0-9A-Z]{12}$|^(?=[0-9A-Z]{20}$)AT\d{18}$|^(?=[0-9A-Z]{22}$)BH\d{2}[A-Z]{4}[0-9A-Z]{14}$|^(?=[0-9A-Z]{16}$)BE\d{14}$|^(?=[0-9A-Z]{20}$)BA\d{18}$|^(?=[0-9A-Z]{22}$)BG\d{2}[A-Z]{4}\d{6}[0-9A-Z]{8}$|^(?=[0-9A-Z]{21}$)HR\d{19}$|^(?=[0-9A-Z]{28}$)CY\d{10}[0-9A-Z]{16}$|^(?=[0-9A-Z]{24}$)CZ\d{22}$|^(?=[0-9A-Z]{18}$)DK\d{16}$|^FO\d{16}$|^GL\d{16}$|^(?=[0-9A-Z]{28}$)DO\d{2}[0-9A-Z]{4}\d{20}$|^(?=[0-9A-Z]{20}$)EE\d{18}$|^(?=[0-9A-Z]{18}$)FI\d{16}$|^(?=[0-9A-Z]{27}$)FR\d{12}[0-9A-Z]{11}\d{2}$|^(?=[0-9A-Z]{22}$)GE\d{2}[A-Z]{2}\d{16}$|^(?=[0-9A-Z]{22}$)DE\d{20}$|^(?=[0-9A-Z]{23}$)GI\d{2}[A-Z]{4}[0-9A-Z]{15}$|^(?=[0-9A-Z]{27}$)GR\d{9}[0-9A-Z]{16}$|^(?=[0-9A-Z]{28}$)HU\d{26}$|^(?=[0-9A-Z]{26}$)IS\d{24}$|^(?=[0-9A-Z]{22}$)IE\d{2}[A-Z]{4}\d{14}$|^(?=[0-9A-Z]{23}$)IL\d{21}$|^(?=[0-9A-Z]{27}$)IT\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^(?=[0-9A-Z]{20}$)[A-Z]{2}\d{5}[0-9A-Z]{13}$|^(?=[0-9A-Z]{30}$)KW\d{2}[A-Z]{4}22!$|^(?=[0-9A-Z]{21}$)LV\d{2}[A-Z]{4}[0-9A-Z]{13}$|^(?=[0-9A-Z]{,28}$)LB\d{6}[0-9A-Z]{20}$|^(?=[0-9A-Z]{21}$)LI\d{7}[0-9A-Z]{12}$|^(?=[0-9A-Z]{20}$)LT\d{18}$|^(?=[0-9A-Z]{20}$)LU\d{5}[0-9A-Z]{13}$|^(?=[0-9A-Z]{19}$)MK\d{5}[0-9A-Z]{10}\d{2}$|^(?=[0-9A-Z]{31}$)MT\d{2}[A-Z]{4}\d{5}[0-9A-Z]{18}$|^(?=[0-9A-Z]{27}$)MR13\d{23}$|^(?=[0-9A-Z]{30}$)MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}$|^(?=[0-9A-Z]{27}$)MC\d{12}[0-9A-Z]{11}\d{2}$|^(?=[0-9A-Z]{22}$)ME\d{20}$|^(?=[0-9A-Z]{18}$)NL\d{2}[A-Z]{4}\d{10}$|^(?=[0-9A-Z]{15}$)NO\d{13}$|^(?=[0-9A-Z]{28}$)PL\d{10}[0-9A-Z]{,16}n$|^(?=[0-9A-Z]{25}$)PT\d{23}$|^(?=[0-9A-Z]{24}$)RO\d{2}[A-Z]{4}[0-9A-Z]{16}$|^(?=[0-9A-Z]{27}$)SM\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^(?=[0-9A-Z]{,24}$)SA\d{4}[0-9A-Z]{18}$|^(?=[0-9A-Z]{22}$)RS\d{20}$|^(?=[0-9A-Z]{24}$)SK\d{22}$|^(?=[0-9A-Z]{19}$)SI\d{17}$|^(?=[0-9A-Z]{24}$)ES\d{22}$|^(?=[0-9A-Z]{24}$)SE\d{22}$|^(?=[0-9A-Z]{21}$)CH\d{7}[0-9A-Z]{12}$|^(?=[0-9A-Z]{24}$)TN59\d{20}$|^(?=[0-9A-Z]{26}$)TR\d{7}[0-9A-Z]{17}$|^(?=[0-9A-Z]{,23}$)AE\d{21}$|^(?=[0-9A-Z]{22}$)GB\d{2}[A-Z]{4}\d{14}$/;

@Component({
  selector: 'app-iban',
  templateUrl: './iban.page.html',
  styleUrls: ['./iban.page.scss'],
})
export class IbanPage implements OnInit, OnDestroy {
  @ViewChild('inputFile', { static: false }) inputFile: ElementRef;
  iban: WalletIban;
  canEditIban: boolean;
  form: FormGroup;
  dataValueChange: Subscription;
  file: string;
  fileName: string;
  fileExt: string;
  defaultFileName: string;
  doc: UploadDocument = {
    type: DOCUMENT_TYPE.IBANScan,
  };

  IBAN_STATUS = IBAN_STATUS;

  constructor(
    private profileService: ProfileService,
    private spinner: SpinnerService,
    private alert: AlertService,
    private auth: AuthService,
    private location: Location,
    protected fb: FormBuilder,
    private platform: Platform,
    private translate: TranslateService,
    private actionSheet: ActionSheetController,
    private camera: Camera
  ) {
    this.form = this.fb.group({
      data: ['', [Validators.required, Validators.pattern(REGEX)]],
      holder: ['', Validators.required],
      dom1: ['', [Validators.required, Validators.maxLength(26)]],
      dom2: ['', [Validators.required, Validators.maxLength(26)]],
    });

    this.dataValueChange = this.form.get('data').valueChanges.subscribe((value = '') => {
      if (value !== value.toUpperCase()) {
        this.form.get('data').setValue(value.toUpperCase());
      }
    });
  }

  ngOnDestroy() {
    if (this.dataValueChange) {
      this.dataValueChange.unsubscribe();
    }
  }

  async ngOnInit() {
    const profile = await this.profileService.getProfile();
    const { firstName = '', lastName = '', vatInfo = {}, type } = profile;
    const { companyName = '' } = vatInfo || {};
    const { wallet = {} as Wallet } = profile || {};
    const { ibans = [] } = wallet || {};
    this.defaultFileName = `IBAN_${firstName}_${lastName}_${moment().format('DD/MMMM/YYYY')}`;

    ibans.sort((a, b) => {
      if (Number(a.id) > Number(b.id)) {
        return -1;
      }
      if (Number(a.id) < Number(b.id)) {
        return 1;
      }
      return 0;
    });

    // IBAN Activated
    const iban = ibans.find(({ status }) => status === IBAN_STATUS.activated);

    if (iban) {
      this.iban = iban;
      this.canEditIban = false;
      this.form.patchValue(this.pick(iban));
      return;
    }

    // Last other IBAN not activated
    this.iban = ibans && ibans[0];
    if (this.iban) {
      this.canEditIban = this.iban.status !== IBAN_STATUS.waiting;
      this.form.patchValue(this.pick(iban));
      return;
    } else {
      // allow user to insert new iban
      this.canEditIban = true;
    }

    // This is the first time user inserts IBAN
    const holder = type === PROFILE_TYPE.private ? `${firstName} ${lastName}` : companyName;
    this.form.patchValue({ holder });
  }

  disabled() {
    // Disabilitato se non carico file
    if (!this.file) {
      return true;
    }
    // Disabilitato se cerco di inserire un iban già inserito e attivo
    const { data } = this.form.value;
    if (this.iban && this.iban.data === data && this.iban.status === IBAN_STATUS.activated) {
      return true;
    }
    return false;
  }

  async save() {
    if (!this.form.valid) {
      setFormTouched(this.form);
      return;
    }

    try {
      await this.spinner.show();
      const token = await this.auth.getToken();

      this.doc.fileName = `${this.defaultFileName}.${this.fileExt}`;
      if (this.fileExt === 'pdf') {
        const splitFile = this.file.split(',');
        splitFile.shift();
        this.doc.buffer = splitFile.join('');
      } else {
        this.doc.buffer = this.file.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
      }
      await this.profileService.uploadDocument(token, this.doc);

      const iban = this.pick(this.form.value);
      await this.profileService.registerIban(token, iban);

      await this.spinner.dismiss();
      await this.alert.toastSuccess();

      await this.profileService.me(token);
      this.location.back();
    } catch (err) {
      await this.spinner.dismissWithAlertError(err);
    }
  }

  pick(iban: WalletIban) {
    const { data, holder, dom1, dom2 } = iban;
    return { data, holder, dom1, dom2 };
  }

  async chooseFile() {
    if (!this.platform.is('cordova')) {
      this.inputFile.nativeElement.click();
      return;
    }
    try {
      const texts = await this.translate
        .get(['UPLOAD_DOCUMENT', 'GALLERY', 'CLOSE', 'CAMERA', 'PDF_DOCUMENT'])
        .toPromise();
      const sheet = await this.actionSheet.create({
        mode: 'md',
        header: texts.UPLOAD_DOCUMENT,
        buttons: [
          {
            text: texts.CAMERA,
            icon: 'camera',
            handler: async () => this.pickPicture(PictureSourceType.CAMERA),
          },
          {
            text: texts.GALLERY,
            icon: 'images',
            handler: async () => this.pickPicture(PictureSourceType.PHOTOLIBRARY),
          },
          {
            text: texts.PDF_DOCUMENT,
            icon: 'document',
            handler: async () => this.inputFile.nativeElement.click(),
          },
          {
            text: texts.CLOSE,
            role: 'cancel',
            icon: 'close',
          },
        ],
      });
      await sheet.present();
    } catch (err) {
      console.log(err);
    }
  }

  async pickPicture(sourceType: PictureSourceType = PictureSourceType.CAMERA) {
    const options: CameraOptions = {
      destinationType: DestinationType.DATA_URL,
      encodingType: EncodingType.JPEG,
      correctOrientation: true,
      sourceType,
      targetWidth: 2048,
      targetHeight: 2048,
    };

    try {
      const imageData = await this.camera.getPicture(options);
      this.file = `data:image/jpeg;base64,${imageData}`;
      this.fileExt = 'jpeg';
      return null;
    } catch (err) {
      console.log(err);
    }
  }

  async inputFileChange(event) {
    const [file = null] = event.target.files || [];
    if (file) {
      this.file = await this.getBase64(event.target.files[0]);
      this.fileName = file.name;
      this.fileExt = file.name.split('.').pop().toLowerCase();
    }
  }

  getBase64(file): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }
}
